import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import { useSelector } from 'react-redux';
import * as CurrencyCodes from 'self-service-api/constants/CurrencyCodes';
import { ENTERPRISE, PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { isUngatedForSeatsSelector } from '../../selectors/GatingSelectors';
import { hasAnyTBSkuInProductDataSelector } from '../../selectors/ProductsSelectors';
import PriceDisplay from '../common/pricing/PriceDisplay';
import PriceChangeBanner from './PriceChangeBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const legacyPriceChanges = {
  [PROFESSIONAL]: {
    [CurrencyCodes.USD]: 2000,
    [CurrencyCodes.EUR]: 1960,
    [CurrencyCodes.GBP]: 1740,
    [CurrencyCodes.AUD]: 2880,
    [CurrencyCodes.JPY]: 240000,
    [CurrencyCodes.SGD]: 2800,
    [CurrencyCodes.CAD]: 2600,
    [CurrencyCodes.COP]: 6000000
  },
  [ENTERPRISE]: {
    [CurrencyCodes.USD]: 5500,
    [CurrencyCodes.EUR]: 5370,
    [CurrencyCodes.GBP]: 4790,
    [CurrencyCodes.AUD]: 7920,
    [CurrencyCodes.JPY]: 660000,
    [CurrencyCodes.SGD]: 7700,
    [CurrencyCodes.CAD]: 7150,
    [CurrencyCodes.COP]: 16500000
  }
};
const tbPriceChanges = {
  [PROFESSIONAL]: {
    [CurrencyCodes.USD]: 1300,
    [CurrencyCodes.EUR]: 1270,
    [CurrencyCodes.GBP]: 1130,
    [CurrencyCodes.AUD]: 1880,
    [CurrencyCodes.JPY]: 156000,
    [CurrencyCodes.SGD]: 1820,
    [CurrencyCodes.CAD]: 1690,
    [CurrencyCodes.COP]: 3900000
  },
  [ENTERPRISE]: {
    [CurrencyCodes.USD]: 4300,
    [CurrencyCodes.EUR]: 4200,
    [CurrencyCodes.GBP]: 3740,
    [CurrencyCodes.AUD]: 6200,
    [CurrencyCodes.JPY]: 516000,
    [CurrencyCodes.SGD]: 6020,
    [CurrencyCodes.CAD]: 5590,
    [CurrencyCodes.COP]: 12900000
  }
};
const CustomerPlatformPriceChangeBanner = () => {
  const currencyCode = useSelector(activeCurrencySelector);
  const isUngatedForSeats = useSelector(isUngatedForSeatsSelector);
  const isSeatsTBPortal = useSelector(hasAnyTBSkuInProductDataSelector);
  const priceChanges = isUngatedForSeats ? isSeatsTBPortal ? tbPriceChanges : null : legacyPriceChanges;
  if (!priceChanges) return null;
  return /*#__PURE__*/_jsx(PriceChangeBanner, {
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.banners.priceChanges.suite.description"
    }),
    tooltip: /*#__PURE__*/_jsx(UIList, {
      styled: true,
      className: "p-left-4 m-bottom-0",
      children: Object.keys(priceChanges).map(productLevel => {
        const price = priceChanges[productLevel][currencyCode];
        return /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: `pricingPage.banners.priceChanges.suite.tooltip.${productLevel}_jsx`,
            elements: {
              Price: PriceDisplay
            },
            options: {
              currencyCode,
              price
            }
          })
        }, productLevel);
      })
    })
  });
};
export default CustomerPlatformPriceChangeBanner;